"use client";

import React, { useEffect, useState } from "react";
import DataLayer from "@/components/data-layer/data-layer";

export default function DestinationPageContentClient({ 
  destinationType, 
  destinationName 
}: { 
  destinationType: string; 
  destinationName: string;
}) {
  const [dataLayerProps, setDataLayerProps] = useState<Record<string, any> | null>(null);

  useEffect(() => {

      setDataLayerProps({
        event: "dataLayerPush",
        pageInformation: {
          pageGroupType: "Destination",
          pageSubgroupType: destinationType,
          pageDestinationName: destinationName
          // Add more fields as needed
        }
      });
  }, [destinationType, destinationName]);

  return dataLayerProps && <DataLayer data={dataLayerProps} />;
}